import { flatMap } from 'lodash/fp';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { compactArray } from '@mews/fp';
import { Taxation } from '@mews-commander/types';
import { getTaxationsByTaxEnvironmentCode } from '@mews-commander/legacy-entities/src/ducks/taxEnvironments';
import { useCommanderSelector } from '@mews-commander/utils';
import { calculateTaxValue } from '../../../../billing/selectors';

export const useCalculateTaxValues = () => {
    const { taxEnvironmentCode } = useCurrentEnterprise();
    const taxations: Taxation[] = useCommanderSelector((state) =>
        getTaxationsByTaxEnvironmentCode(state, { taxEnvironmentCode })
    );

    const taxRates = flatMap((taxation) => taxation.taxRates, taxations);

    return ({ taxValues, value }: { value: number; taxValues: Record<string, string> }) =>
        compactArray(
            Object.values(taxValues).map((taxRateCode) => {
                if (!taxRateCode) return null;

                return calculateTaxValue(taxRateCode, taxRates, value);
            })
        );
};
